import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 text-sm" data-id="element-81">
      <div className="container px-4 mx-auto max-w-4xl text-center space-y-6" data-id="element-82">
        <p className="font-bold text-slate-300" data-id="element-83">
          © 2026 KIT Psicología en Deporte Adaptado. Todos los derechos
          reservados.
        </p>

        <p className="leading-relaxed text-xs" data-id="element-84">
          Este material está dirigido a profesionales de la salud mental y no
          reemplaza evaluación médica, psicológica clínica, psiquiátrica,
          fisioterapéutica, neurológica, kinesiológica ni supervisión
          profesional cuando corresponda.
        </p>

        <p className="leading-relaxed text-xs" data-id="element-85">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
}